import { api } from '../../api.js'
import { config } from '../../config.js'

const actions = {
    FRONT_QUESTIONS_INDEX: function({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.faqs.index'), data)
                .then(res => {
                    resolve(res)
                })
                .catch(error => {
                    console.log(error)
                    reject(error)
                })
        })
    },
    FRONT_QUESTIONS_SHOW : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.faqs.show'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    }
}

export default {
    actions
}
